export const baseColumnList = () => {
  return [
    {
      field: 'contractMatterName',
      title: '合同标的',
      width: 150,
      editRender: { name: 'contractMatterName' },
    },
    {
      field: 'materialType',
      width: 150,
      title: '料型',
      editRender: { name: 'materialType' },
    },
    {
      field: 'productQuantity',
      width: 150,
      title: '销售数量',
      editRender: { name: 'productQuantity' },
    },
    {
      field: 'businessContractUnitPrice',
      width: 150,
      title: '合同单价',
      editRender: { name: 'businessContractUnitPrice' },
    },
    {
      field: 'businessContractTotalAmount',
      width: 150,
      title: '价税合计金额',
      editRender: { name: 'businessContractTotalAmount' },
    },
    {
      field: 'taxRate',
      width: 150,
      title: '增值税',
      editRender: { name: 'taxRate' },
    },
    {
      field: 'isFixedPrice',
      title: '是否定价',
      width: 150,
      showHeaderOverflow: true,
      editRender: { name: 'isFixedPrice' },
    },
    {
      field: 'businessChangeUnitPrice',
      title: '变动单价',
      width: 150,
      editRender: { name: 'businessChangeUnitPrice' },
    },
    {
      field: 'priceConfirmDate',
      title: '价格确定时间',
      width: 150,
      editRender: { name: 'priceConfirmDate' },
    },
    {
      field: 'priceIdentity',
      width: 150,
      title: '价格标识',
      editRender: { name: 'priceIdentity' },
    },
    {
      field: 'shipmentPlace',
      width: 150,
      title: '起运地',
      editRender: { name: 'shipmentPlace' },
    },
    {
      field: 'destination',
      width: 150,
      title: '目的地',
      editRender: { name: 'destination' },
    },
    {
      field: 'unit',
      title: '单位',
      width: 150,
      showHeaderOverflow: true,
      editRender: { name: 'unit' },
    },
  ];
};

export const baseTableRule = () => {
  return {
    isFixedPrice: [{ required: true, message: '必填字段', trigger: 'change' }],
    taxRate: [{ required: true, message: '必填字段', trigger: 'change' }],
    contractMatterName: [{ required: true, message: '必填字段', trigger: ['blur', 'change'] }],
    productQuantity: [
      {
        required: true,
        message: '必填字段',
        trigger: ['blur', 'change'],
      },
    ],
  };
};
